import emoji from 'react-easy-emoji';
import splashAnimation from './assets/lottie/splashAnimation';

// ─────────────────────────────────────────────
// Splash Screen
// ─────────────────────────────────────────────
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 3000,
};

// ─────────────────────────────────────────────
// Illustration
// ─────────────────────────────────────────────
const illustration = {
  animated: true,
};

// ─────────────────────────────────────────────
// Greeting
// ─────────────────────────────────────────────
const greeting = {
  username: 'Samuel Douglas Othieno',
  title: "Hi, I'm Douglas",
  subTitle: emoji(
    'A passionate Full-Stack Software Developer with experience spanning web development and quality assurance. I build fast, accessible web applications with JavaScript / React.js / Node.js and other modern libraries and frameworks.',
  ),
  resumeLink:
    'https://drive.google.com/file/d/1_MVGpQdYIE11AiRXiKgwQN-eUj86QEOW/view?usp=sharing',
  displayGreeting: true,
};

// ─────────────────────────────────────────────
// Social Media Links
// ─────────────────────────────────────────────
const socialMediaLinks = {
  github: 'https://github.com/samuel-othieno',
  linkedin: 'https://www.linkedin.com/in/samuel-douglas-othieno-80484628a/',
  gmail: 'douglasothieno@gmail.com',
  instagram:
    'https://www.instagram.com/samuel.othieno?igsh=MWU4dzRsaWx2c2ZnbA==',
  facebook: 'https://www.facebook.com/samuel.othieno.330',
  medium: 'https://medium.com/@douglasothieno',
  stackoverflow:
    'https://stackoverflow.com/users/22467261/samuel-othieno-douglas',
  // Twitter / X handle — used for the social icon link
  twitter: 'https://twitter.com/douglasothieno',

  // To customize icons and social links, tweak src/components/SocialMedia
  display: true,
};

// ─────────────────────────────────────────────
// Skills Section
// Accessibility note: emoji() renders decorative emoji that are
// aria-hidden by react-easy-emoji, keeping screen-reader output clean.
// ─────────────────────────────────────────────
const skillsSection = {
  title: 'What I do',
  subTitle: 'PASSIONATE FULL-STACK DEVELOPER',
  skills: [
    emoji(
      '⚡ Build highly interactive front-end / user interfaces for web and mobile applications',
    ),
    emoji('⚡ Develop Progressive Web Applications (PWA) in standard and SPA stacks'),
    emoji(
      '⚡ Integrate third-party services such as Firebase, AWS, and Digital Ocean',
    ),
  ],

  softwareSkills: [
    {
      skillName: 'HTML5',
      fontAwesomeClassname: 'fab fa-html5',
    },
    {
      skillName: 'CSS3',
      fontAwesomeClassname: 'fab fa-css3-alt',
    },
    {
      skillName: 'Sass',
      fontAwesomeClassname: 'fab fa-sass',
    },
    {
      skillName: 'JavaScript',
      fontAwesomeClassname: 'fab fa-js',
    },
    {
      skillName: 'React.js',
      fontAwesomeClassname: 'fab fa-react',
    },
    {
      skillName: 'Node.js',
      fontAwesomeClassname: 'fab fa-node',
    },
    {
      skillName: 'npm',
      fontAwesomeClassname: 'fab fa-npm',
    },
    {
      skillName: 'SQL Database',
      fontAwesomeClassname: 'fas fa-database',
    },
    // FIX: 'fab fa-render' does not exist in Font Awesome.
    // Replaced with a valid server icon that represents cloud/hosting.
    {
      skillName: 'Cloud / Hosting',
      fontAwesomeClassname: 'fas fa-server',
    },
    {
      skillName: 'Firebase',
      fontAwesomeClassname: 'fas fa-fire',
    },
    {
      skillName: 'Docker',
      fontAwesomeClassname: 'fab fa-docker',
    },
  ],
  display: true,
};

// ─────────────────────────────────────────────
// Education Section
// ─────────────────────────────────────────────
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: 'Kanzu Code Foundation',
      logo: require('./assets/images/kanzucode.png'),
      // FIX: "developemt" → "development"
      subHeader: 'Certificate in Software Development',
      duration: 'August 2023 – June 2024',
      // FIX: "Fron-end" → "Front-end"
      desc: 'Covered concepts in front-end and back-end technologies',
      descBullets: [
        'Front-end: HTML, CSS, JavaScript, Figma, Mantine, Tailwind, Next.js, Auth0, Strapi',
        'Back-end: Node.js, Express.js, PostgreSQL, NestJS, TypeScript',
      ],
    },
    {
      schoolName: 'freeCodeCamp (Online Learning)',
      logo: require('./assets/images/freecode.png'),
      // FIX: "developemt" → "development"
      subHeader: 'Certificates in Software Development',
      // FIX: Added proper date range; capitalised "June"
      duration: 'January 2023 – June 2023',
      desc: 'Covering concepts in front-end development',
      descBullets: [
        'Responsive Web Design certification — Completed',
        'JavaScript Algorithms and Data Structures certification — Completed',
      ],
    },
    {
      schoolName: 'Makerere University',
      logo: require('./assets/images/muk.png'),
      // FIX: "Adminstration" → "Administration"
      subHeader: 'Bachelor of Business Administration',
      duration: 'March 2020 – June 2023',
      desc: 'Finance Major',
      descBullets: [
        'Participated in the National CFA Institute Equity Research Challenge on MTN Uganda 2023',
        'Graduated with a Second Class Upper Division',
        // FIX: "anagement" → "Management"
        'Completed relevant coursework in Finance & Accounting, ICT, Strategic Management, and Human Resource Management',
      ],
    },
  ],
};

// ─────────────────────────────────────────────
// Tech Stack / Experience Bars
// FIX: Adjusted percentages to reflect frontend-focused career.
// UI/UX lifted; Frontend raised to match actual work experience.
// ─────────────────────────────────────────────
const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: 'UI/UX Design',
      progressPercentage: '65%',
    },
    {
      Stack: 'Frontend',
      progressPercentage: '85%',
    },
    {
      Stack: 'Backend',
      progressPercentage: '75%',
    },
  ],
  displayCodersrank: false,
};

// ─────────────────────────────────────────────
// Work Experience Section
// ─────────────────────────────────────────────
const workExperiences = {
  display: true,
  experience: [
    {
      role: 'Data Systems Analyst',
      company: 'Next Media (AfroMobile)',
      companylogo: require('./assets/images/Nextmedia.png'),
      date: 'November 2024 – Present',
      desc: 'AfroMobile is a digital streaming platform offering users seamless access to Live TV, Live Radio, Podcasts, Video on Demand (VOD), and other interactive media experiences.',
      descBullets: [
        'Design and maintain ETL pipelines for app performance data.',
        'Build dynamic dashboards to visualise revenue, engagement, and retention metrics.',
        'Generate daily, weekly, and monthly performance reports for stakeholders.',
        'Monitor app logs to detect crashes, streaming issues, and performance degradation.',
        'Conduct UI/UX audits to identify friction points and recommend improvements.',
        'Document QA processes to ensure transparency and auditability.',
      ],
    },
    {
      role: 'Software Developer',
      // FIX: "SOUCE.io" → "SOURCE.io" | "Fiancial" → "Financial"
      company: 'Amarin Financial Group (SOURCE.io)',
      companylogo: require('./assets/images/amarin.png'),
      // FIX: "N0v" → "Nov"
      date: 'January 2024 – November 2024',
      desc: 'SOURCE is a digital expense and income management platform that helps SMEs manage expenses, income, and financial requests efficiently. It streamlines workflows like invoice generation, approvals, and cash tracking before formal accounting begins.',
      descBullets: [
        'Developed and maintained frontend components using React.js.',
        'Implemented client-side validation for forms and financial inputs.',
        'Debugged and resolved frontend issues across staging and production environments.',
        'Documented component logic and user interactions for team handoff.',
        'Tested new features and ensured cross-browser compatibility.',
        'Supported QA teams in verifying UI behaviour and bug fixes.',
      ],
    },
    {
      role: 'Software Developer',
      company: 'Uganda Securities Exchange (USE Easy Portal)',
      companylogo: require('./assets/images/USE.png'),
      // FIX: "N0v" → "Nov"
      date: 'August 2023 – November 2023',
      desc: 'USE Easy Portal is a web-based platform developed for the Uganda Securities Exchange to streamline investor access to market data, account management, and trading services. It simplifies interactions between brokers, issuers, and investors through a secure digital interface.',
      descBullets: [
        'Assisted in building user-friendly interfaces for investor account access.',
        'Supported integration of APIs for market data and trading workflows.',
        'Helped implement secure login and role-based access controls.',
        'Debugged UI issues and tested portal features across multiple browsers.',
        'Collaborated with senior developers to refine portal functionality.',
        'Learned best practices in secure financial web application development.',
      ],
    },
    {
      role: 'Software Developer',
      company: 'SwiftDoc Uganda',
      companylogo: require('./assets/images/swiftdoc.png'),
      date: 'December 2023 – April 2024',
      desc: 'SwiftDoc Uganda is a telemedicine platform that connects patients with licensed doctors for remote consultations, prescriptions, and follow-up care — making healthcare more accessible, efficient, and secure.',
      descBullets: [
        'Developed responsive web interfaces using React.js and Tailwind CSS.',
        'Integrated secure video and chat modules for doctor-patient consultations.',
        'Collaborated with designers and medical advisors to refine user flows.',
        'Connected frontend to back-end APIs for patient data and consultation history.',
        'Tested and debugged UI components across devices and browsers.',
        'Documented component logic and API interactions for handoff and QA.',
      ],
    },
  ],
};

// ─────────────────────────────────────────────
// Open Source
// ─────────────────────────────────────────────

/*
 * To learn how to get your GitHub key, see README.md.
 * FIX: showGithubProfile was a string 'true' — changed to boolean true
 * so strict equality checks (=== true) work correctly.
 */
const openSource = {
  showGithubProfile: true,
  display: true,
};

// ─────────────────────────────────────────────
// Big Projects
// ─────────────────────────────────────────────
const bigProjects = {
  title: 'My Projects',
  // FIX: "SOME STARTUPS" → more descriptive subtitle
  subtitle: 'PRODUCTS I HAVE BUILT',
  projects: [
    {
      image: require('./assets/images/swiftdoc.png'),
      // FIX: projectName was set to 'Samuel Douglas Othieno' (author name) — corrected to project name
      projectName: 'SwiftDoc Uganda',
      projectDesc:
        'SwiftDoc.ug is an online medical web application with the sole purpose of improving healthcare in Uganda by making medical service delivery easier and more accessible.',
      footerLink: [
        {
          name: 'Visit SwiftDoc',
          url: 'https://swiftdocug.vercel.app/',
        },
      ],
    },
    {
      image: require('./assets/images/instamed.jpeg'),
      projectName: 'InstaMedi',
      projectDesc:
        'An online medical web application that aims to deliver better medical services in Uganda through a fast, accessible digital platform.',
      footerLink: [
        {
          name: 'Visit InstaMedi',
          url: 'https://instamed.vercel.app/',
        },
      ],
    },
    {
      image: require('./assets/images/API.png'),
      projectName: 'Quote API',
      // FIX: "his is" → "This is"
      projectDesc:
        'This is a Quote API built with Node.js, Express.js, and PostgreSQL, among other tools. It serves structured quote data via RESTful endpoints.',
      footerLink: [
        {
          name: 'View API Docs',
          url: 'https://documenter.getpostman.com/view/31550077/2sA3Bn5CEB',
        },
      ],
    },
    {
      image: require('./assets/images/githubPG.jpeg'),
      projectName: 'GitHub Profile Generator',
      projectDesc:
        'An application that fetches data from the GitHub API and renders a clean, shareable profile card for any GitHub user.',
      footerLink: [
        {
          name: 'Visit App',
          url: 'https://github-profile-generator-tau.vercel.app/',
        },
      ],
    },
    {
      image: require('./assets/images/task.jpeg'),
      projectName: 'Task Management Tool',
      projectDesc: 'A task management tool built with React for organising, tracking, and prioritising daily tasks.',
      footerLink: [
        {
          name: 'Visit App',
          url: 'https://java-script-project-1-kappa.vercel.app/',
        },
      ],
    },
    {
      image: require('./assets/images/postit.jpeg'),
      projectName: 'PostIt',
      projectDesc:
        'PostIt is a group notification application that allows friends and colleagues to create groups and broadcast messages to everyone at once. Users can create accounts, form groups, add registered members, and send messages to those groups.',
      footerLink: [
        // FIX: name was 'github profile generator' — corrected to 'PostIt'
        {
          name: 'PostIt on GitHub',
          url: 'https://github.com/Samuel-othieno/PostIt.git',
        },
      ],
    },
  ],
  display: true,
};

// ─────────────────────────────────────────────
// Achievement Section
// ─────────────────────────────────────────────
const achievementSection = {
  title: emoji('Achievements & Certifications 🏆'),
  subtitle:
    'Certifications, award letters, and milestones from my learning journey.',

  achievementsCards: [
    {
      title: 'Backend JavaScript Web Development Bootcamp — Cohort 4',
      subtitle: 'Certificate of Completion',
      image: require('./assets/images/samueldouglas.jpg'),
      imageAlt:
        'Certificate recognising the successful completion of the Kanzu Code Foundation Back-End JavaScript Web Development Bootcamp, Cohort 4.',
      footerLink: [
        {
          name: 'View Certificate',
          url: 'https://www.dropbox.com/scl/fi/ufxsob5lzk11l83vxq6pt/certificate.jpg?rlkey=u56p7cctjimhwpacojfuayyxf&st=xj9te8pg&dl=0',
        },
      ],
    },
    {
      title: 'JavaScript Web Development Bootcamp — Cohort 4',
      subtitle: 'Certificate of Completion',
      image: require('./assets/images/bootcamp.jpeg'),
      imageAlt:
        'Certificate recognising the successful completion of the Kanzu Code Foundation Frontend JavaScript Web Development Bootcamp, Cohort 4.',
      footerLink: [
        {
          name: 'View Certificate',
          url: 'https://www.dropbox.com/scl/fi/to1fzzff9bo87l0xm4vdd/Frontend.jpeg?rlkey=u4zzbguz79d2gig6jmh5fqm6d&st=q3ewyeyl&dl=0',
        },
      ],
    },
  ],
  display: true,
};

// ─────────────────────────────────────────────
// Blogs Section
// ─────────────────────────────────────────────
const blogSection = {
  title: 'Blog',
  subtitle:
    'I love building cool things and sharing what I learn along the way.',
  // FIX: was string 'true' — changed to boolean true
  displayMediumBlogs: true,
  blogs: [
    {
      url: 'https://medium.com/@douglasothieno/the-ultimate-guide-to-learning-web-development-from-industry-experts-and-mentors-ef6a457a5341',
      title:
        'The Ultimate Guide to Learning Web Development from Industry Experts and Mentors',
      description:
        'Have you ever wondered how to learn web development from the best in the industry?',
    },
    {
      url: 'https://medium.com/@douglasothieno/how-github-boosted-my-web-development-skills-6c9bcba7e43f',
      title: 'How GitHub Boosted My Web Development Skills: A Personal Story',
      description:
        'How I used GitHub to learn from other developers and accelerate my growth.',
    },
    {
      url: 'https://medium.com/@douglasothieno/unlocking-potential-the-kanzu-code-foundation-bootcamp-a0fb27d73219',
      title: 'Unlocking Potential: The Kanzu Code Foundation Bootcamp',
      description: 'Empowering aspiring software engineers in Uganda.',
    },
    {
      url: 'https://medium.com/@douglasothieno/how-coding-is-changing-my-life-and-career-d6a25018ad60',
      title: 'How Coding Is Changing My Life and Career',
      description:
        'Coding is not just a career for me — it is a passion and a way of life.',
    },
    {
      url: 'https://medium.com/@douglasothieno/from-finance-to-frontend-my-tech-journey-and-where-i-see-myself-in-the-next-5-years-be7690c3920c',
      title:
        'From Finance to Frontend: My Tech Journey and Where I See Myself in the Next 5 Years',
      description: 'A personal reflection on switching careers into tech.',
    },
  ],
  display: true,
};

// ─────────────────────────────────────────────
// Talks Section
// FIX: Placeholder '#' URLs and a placeholder talk title were left in.
// Set display: false until you have a real talk to showcase.
// When you do, replace the entry below with your actual talk details.
// ─────────────────────────────────────────────
const talkSection = {
  title: 'TALKS',
  subtitle: emoji(
    'I love sharing what I know and connecting with the developer community 😊',
  ),

  talks: [
    // Add your real talks here, for example:
    // {
    //   title: 'Building Accessible Web Apps with React',
    //   subtitle: 'Kanzu Code Community Meetup, Kampala',
    //   slides_url: 'https://your-slides-url.com',
    //   event_url: 'https://your-event-url.com',
    // },
  ],
  // FIX: Hidden until real talk data is available
  display: false,
};

// ─────────────────────────────────────────────
// Podcast Section
// FIX: podcast: [''] (empty string) can cause broken embed renders.
// Changed to an empty array and hidden until a real podcast link exists.
// ─────────────────────────────────────────────
const podcastSection = {
  title: emoji('Podcast 🎙️'),
  subtitle: 'I love talking about technology and sharing my experiences.',

  // Add your podcast embed link here when ready, e.g.:
  // podcast: ['https://anchor.fm/your-show/embed/episodes/...'],
  podcast: [],
  display: false,
};

// ─────────────────────────────────────────────
// Resume Section
// ─────────────────────────────────────────────
const resumeSection = {
  title: 'Resume',
  subtitle: 'Feel free to download my resume',
  display: true,
};

// ─────────────────────────────────────────────
// Contact Info
// ─────────────────────────────────────────────
const contactInfo = {
  title: emoji('Contact Me ☎️'),
  subtitle:
    'Have a project in mind or just want to say hi? My inbox is always open.',
  number: '+256-785-095154',
  email_address: 'douglasothieno@gmail.com',
};

// ─────────────────────────────────────────────
// Twitter / X Section
// NOTE: Twitter's API is now paid-tier. If this section causes errors
// or renders empty, set display: false and link Twitter via socialMediaLinks
// instead (already added above as 'twitter').
// ─────────────────────────────────────────────
const twitterDetails = {
  userName: 'douglasothieno',
  display: false,
};

// ─────────────────────────────────────────────
// Hireable Status
// ─────────────────────────────────────────────
const isHireable = true;

// ─────────────────────────────────────────────
// Exports
// ─────────────────────────────────────────────
export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
};